import React from "react";
import NoImage from "./NoImage";
import HasImage from "./HasImage";

function SolutionArea({ image, anchorId, ...others }) {
  return image ? (
    <HasImage anchorId={anchorId} image={image} {...others} />
  ) : (
    <NoImage anchorId={anchorId} {...others} />
  );
}

export default SolutionArea;
